import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { nonPaymentRegistrationSlice } from "redux/features/nonPaymentRegistration";
import IconButton from "util/iconButton";
import { FaTimes } from "react-icons/fa";
import { Message, Box } from "react-bulma-components";

import ErrorMessage from "util/errorMessage";
import displayHTMLReceipt from "util/receipts";

export function useNonPaymentRegistrationState(personId) {
  const [instanceId, setInstanceId] = useState(null);

  const nonPaymentRegistration = useSelector(
    nonPaymentRegistrationSlice.selector
  );

  const inProgress =
    instanceId === nonPaymentRegistration.instanceId &&
    personId === nonPaymentRegistration.personId
      ? nonPaymentRegistration
      : null;

  const dispatch = useDispatch();

  const start = (data) => {
    const newInstanceId = 1 + nonPaymentRegistration.instanceId;
    setInstanceId(newInstanceId);
    dispatch(
      nonPaymentRegistrationSlice.asyncActions.submit(
        personId,
        newInstanceId,
        data
      )
    );
  };

  const close = () => {
    setInstanceId(null);
    dispatch(nonPaymentRegistrationSlice.actions.clear());
  };

  return { inProgress, start, close };
}

export function NonPaymentRegistration({ state, onFinished }) {
  useEffect(() => {
    if (onFinished && !state.inProgress) onFinished();
  }, [state.inProgress, onFinished]);

  const { pending, data, error = {} } = state.inProgress || {};

  const closeButton = (
    <div className="buttons">
      <IconButton icon={FaTimes} onClick={state.close}>
        Close
      </IconButton>
    </div>
  );

  if (pending) {
    return (
      <Message color="info">
        <Message.Body>
          <p>Processing registration; please wait.</p>
        </Message.Body>
      </Message>
    );
  } else if (data) {
    const receipt = data.receipt || [
      "Registration was successful, but an unknown error occurred " +
        "displaying the receipt.",
    ];
    return (
      <Box>
        {displayHTMLReceipt(receipt)}
        {closeButton}
      </Box>
    );
  } else {
    return (
      <ErrorMessage header="Registration Failed">
        {error.message || "Un unknown error occurred"} {closeButton}
      </ErrorMessage>
    );
  }
}
